import { render, staticRenderFns } from "./ModalErroValidacaoJob.vue?vue&type=template&id=05dea8e5"
import script from "./ModalErroValidacaoJob.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalErroValidacaoJob.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports